<template>
    <div class="page-container">
        <!-- <el-breadcrumb separator="｜">
          <el-breadcrumb-item >任务考核数据</el-breadcrumb-item>
          <el-breadcrumb-item>考核周期设置</el-breadcrumb-item>
          <el-breadcrumb-item>考核达成率设置</el-breadcrumb-item>
      </el-breadcrumb> -->
        <div class="page-container-header">
            <span
                @click="onHeader(item)"
                v-for="item in headerData"
                :key="item.id"
                :class="item.id === currentPage ? 'active' : ''"
                >{{ item.label }}
            </span>
        </div>
        <el-card v-if="currentPage === '1'" class="page-content" shadow="never">
            <div class="page-actions">
                <el-select :value="queryType" @change="setQueryType" placeholder="请选择">
                    <el-option
                        v-for="item in queryTypeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
                <el-input
                    placeholder="请输入内容"
                    clearable
                    v-model="queryValue"
                    @change="setQueryValue"
                >
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
                <el-button type="primary" @click="handleSearch">搜索</el-button>
            </div>
            <user-list @refresh="refreshList"></user-list>
        </el-card>
        <div v-else :key="currentObj.value">
            <Siteconf :isShowBreadcrumb="false" :current-key="currentObj.value" />
        </div>
    </div>
</template>

<script>
import './store';
import UserList from './components/list';
import { mapState, mapActions, mapMutations } from 'vuex';
import Siteconf from '@/entries/Setting/Siteconf/index.vue';
import { QUERY_TYPE, PAGINATION } from './constants';
const HEADER_DATA = [
    {
        label: '任务考核数据',
        id: '1',
    },
    {
        label: '任务考核数据',
        id: '2',
        value: 'user_task_cycle_time',
    },
    {
        label: '任务考核数据',
        id: '3',
        value: 'user_task_cycle_completion_rate',
    },
];
export default {
    name: 'User',
    components: {
        UserList,
        Siteconf,
    },
    data() {
        return {
            queryValue: '',
            currentPage: '1',
            headerData: HEADER_DATA,
            currentObj: {},
        };
    },
    computed: {
        ...mapState('assess', ['queryType', 'queryTypeList', 'pagination']),
    },
    methods: {
        ...mapActions('assess', ['list']),
        ...mapMutations('assess', ['setQueryType', 'setQueryValue']),
        refreshList(data = {}) {
            this.list({
                queryType: this.queryType,
                queryValue: this.queryValue,
                ...this.pagination,
                ...data,
            });
        },
        handleSearch() {
            this.list({
                queryType: this.queryType,
                queryValue: this.queryValue,
                ...PAGINATION,
            });
        },
        onHeader(item) {
            this.currentPage = item.id;
            this.currentObj = item;
        },
    },
    created() {
        // this.list({
        //     queryType: QUERY_TYPE[0].value,
        //     queryValue: this.queryValue,
        //     ...PAGINATION,
        // });
    },
};
</script>

<style lang="less" scoped>
.page-container-header {
    display: flex;
    font-size: 14px;
    > span {
        margin-right: 15px;
        cursor: pointer;
    }
    .active {
        color: #409eff;
        font-weight: bold;
    }
}
</style>
